{
	"title": "Управление на декларации",
	"createDeclaration": "Създай декларация"
}
